<div class="p-base pb-xl">
  <div class="text-base leading-base font-semibold">{{ label }}</div>
</div>

<div class="flex-1 flex flex-col border-t border-gray-100">
  <div class="flex-1 flex flex-col">
    <form
      [formGroup]="dateForm"
      class="flex items-center mb-sm md:mb-xs -mt-sm pt-2xl md:pt-lg px-base md:pb-0"
    >
      <div class="flex-1">
        <lla-input
          class="w-full"
          size="small"
          controlName="dateText"
          [label]="'Date'"
          type="text"
        ></lla-input>
      </div>
    </form>

    <div class="flex-1 px-xs pb-0">
      <mat-calendar
        #calendar
        class="mg-date-picker-calendar"
        [selected]="selectedDate"
        (selectedChange)="onSelectedDateChange($event)"
        [maxDate]="calendarMaxDate"
        [minDate]="minDate ?? undefined"
      ></mat-calendar>
    </div>
  </div>
</div>

<div class="hidden md:flex items-center justify-end p-base border-t border-ui-separator">
  <lla-button class="mr-2xl" variant="ghost" size="medium-shrink" (click)="cancelled.emit()">
    Cancel
  </lla-button>
  <lla-button
    variant="ghost"
    size="medium-shrink"
    extraBtnClass="!text-primary"
    (click)="fireValueChangedEvent()"
  >
    Apply
  </lla-button>
</div>

<div class="px-base flex md:hidden flex-col gap-xs">
  <lla-button size="medium" (click)="fireValueChangedEvent()"> Apply </lla-button>
  <lla-button variant="ghost" size="medium" extraBtnClass="!text-primary" (click)="cancelled.emit()">
    Cancel
  </lla-button>
</div>
